export default __webpack_public_path__ + "static/section_4_details_8-59b0496881e36e9cae4f73d7bfa68ea3.png";